module.exports = __webpack_public_path__ + "3cf86b5a7881654b8d7694cd3563be15.woff";